import React from 'react';
import './BlockComponent.css';

export default function ImageBlock(props) {
  const { src, displayHeight, linkDestination } = props.data;
  return (
    <div className="imageblock-image-wrapper">
      <a href={linkDestination} target="_blank" rel="noopener noreferrer">
        <img className="imageblock-image" src={src} style={{ maxHeight: `${displayHeight}px` }} alt="" />
      </a>
    </div>
  );
}
